export class SnackBarModel {
  snackBarSuccess: boolean = false;
  showSnackBar: boolean = false;
  snackBarMessage: string = '';
}
